/** @jsx jsx */

import React, { Fragment as _, useState, useRef, useEffect } from 'react';
import { css, jsx } from '@emotion/core';
import colors from '../variables';
import LoadingSpinner from 'components/UI/LoadingSpinner';
import ThumbnailContainer from '../ThumbnailContainer';

const { lPink, lGrey0, lGrey1, lGrey2, blue0, blue1, lightGrey } = colors;

const cache = {};

const YourImagePreview = ({ data, selected, setSelected }) => {
  const [loaded, setLoaded] = useState(cache[data.url]);

  const mounted = useRef(true);

  let name = data.url.split(/\//g);
  name = name[name.length - 1];

  useEffect(() => {
    if (cache[data.url]) {
      return;
    }

    const img = new Image();
    img.src = data.url;

    img.onload = () => {
      mounted.current && setLoaded((cache[data.url] = true));
    };
  }, [data]);

  useEffect(() => () => { mounted.current = false }, []);

  return (
    <ThumbnailContainer
      selected={selected && selected.url === data.url}
      label={name}
      onClick={setSelected}
    >
      <_>
        {loaded ? (
          <img
            src={data.url}
            css={css`
              height: 100%;
              object-fit: contain;
            `}
          />
        ) : (
            <LoadingSpinner />
          )}
      </_>
    </ThumbnailContainer>
  );
};

export default YourImagePreview;
